import { useSetState } from "Helpers/Hooks";
import React, { useEffect, useState, Fragment } from "react";
import { read, store } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUserGroupCombo,
  changeProjectSearch,
  getAllProjectCustomerList,
  selectCustomerForAdmin,
  getCustomerList,
} from "Stores/actions";
import { Grid } from "@material-ui/core";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import {
  ALL_PROJECT_LIST,
  SELECTED_CUSTOMER,
  SELECTED_CUSTOMER_ADMIN,
  SELECTED_USER,
} from "Stores/actionTypes";
import Input from "Components/Input/Input";
import { useTranslation } from "react-i18next";

export default function ProjectBox({ ALoad }) {
  const { t } = useTranslation();
  const readls = read("lsProjectDataSearch");
  const {
    allUserGroupForAdmin,
    allCustomerForAdmin,
    allProjectComboUser,
    projectsListPagination,
    projectDataSearch,
    projectsList,
    selectedProject,
    allCustomers,
    selectedCustomer,
  } = useSelector((state) => ({
    allUserGroupForAdmin: state.project.allUserGroupForAdmin,
    allCustomerForAdmin: state.project.allCustomerForAdmin,
    allProjectComboUser: state.project.allProjectComboUser,
    projectsListPagination: state.project.projectsListPagination,
    projectDataSearch: state.project.projectDataSearch,
    projectsList: state.project.projectsList,
    selectedProject: state.project.selectedProject,
    allCustomers: state.project.allCustomers,
    selectedCustomer: state.project.selectedCustomer,
  }));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    users: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      display: false,
    },
    customers: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      display: true,
    },
    customersType: {
      type: "select",
      selectItems: [
        { label: t("cusall"), value: 0 },
        { label: t("cusreg"), value: 1 },
        { label: t("cusshop"), value: 2 },
      ],
      value: { label: t("cusall"), value: 0 },
      validation: null,
      display: true,
    },
  });

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const mac = document.getElementById("main-admin-content");

        // first load
        if (readls && !projectDataSearch)
          dispatch(changeProjectSearch({ ...readls }));

        // set name for search
        let NameSearch = null;
        if (projectDataSearch?.Name) NameSearch = projectDataSearch.Name;
        else if (readls?.Name) {
          NameSearch = readls.Name;
          dispatch(
            changeProjectSearch({ ...projectDataSearch, Name: readls.Name }),
          );
        } else NameSearch = null;

        // select display
        if (ALoad) {
          const params = {
            Key: read("groupKey"),
            KeyUs: read("userKey"),
            All: true,
          };
          const response = await dispatch(selectUserGroupCombo(params));
          //dispatch({ type: SELECTED_USER, selectedUser: response[0] });
          // set users filter
          let usersValue = null;
          if (projectDataSearch?.users) usersValue = projectDataSearch.users;
          else if (readls?.users) usersValue = readls.users;
          else usersValue = response[0];

          const paramsCustomer = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            KeyRequestUser: usersValue.value,
            All: true,
          };
          const responseCustomer = await dispatch(
            selectCustomerForAdmin(paramsCustomer),
          );
          //dispatch({ type: SELECTED_CUSTOMER_ADMIN, selectedCustomerAdmin: responseCustomer[0] });
          // set customers filter
          let customersValue = null;
          if (projectDataSearch?.customers)
            customersValue = projectDataSearch.customers;
          else if (readls?.customers) customersValue = readls.customers;
          else customersValue = responseCustomer[0];

          // set pagination filter
          let pagination = 1;
          if (mac.clientWidth > 768) {
            if (projectDataSearch?.pagination)
              pagination = projectDataSearch.pagination;
            else if (readls?.pagination) pagination = readls.pagination;
            else pagination = projectsListPagination.Page;
          }

          dispatch({ type: SELECTED_USER, selectedUser: usersValue });
          dispatch({
            type: SELECTED_CUSTOMER_ADMIN,
            selectedCustomerAdmin: customersValue,
          });

          await ongetAllProjectCustomerList(
            usersValue.value,
            customersValue.value,
            NameSearch,
            pagination,
          );
        } else {
          setControls({ users: { display: ALoad } });
          const params = {
            keyGroup: read("groupKey"),
            keyUser: read("userKey"),
            All: true,
          };
          const response = await dispatch(getCustomerList(params));

          // set customers filter
          let customersValue = null;
          if (projectDataSearch?.customers)
            customersValue = projectDataSearch.customers;
          else if (readls?.customers) customersValue = readls.customers;
          else customersValue = response[0];

          // set pagination filter
          let pagination = 1;
          if (mac.clientWidth > 768) {
            if (projectDataSearch?.pagination)
              pagination = projectDataSearch.pagination;
            else if (readls?.pagination) pagination = readls.pagination;
            else pagination = projectsListPagination.Page;
          }

          dispatch({
            type: SELECTED_CUSTOMER,
            selectedCustomer: customersValue,
          });
          await ongetAllProjectCustomerList(
            -1,
            customersValue.value,
            projectDataSearch?.Name,
            pagination,
          );
        }
      } catch {
        setLoading(false);
      }
    })();
  }, []);

  // useEffect(() => {
  //   if(projectDataSearch?.changeOut) {
  //     if(projectDataSearch.customers === -1) {
  //       setControls({ customers: { value: controls.customers.selectItems[0] } });
  //       dispatch(changeProjectSearch({ ...projectDataSearch, changeOut: false }));
  //       store('lsProjectDataSearch', { ...projectDataSearch, customers: controls.customers.selectItems[0] });
  //     } else {
  //       if(ALoad) {
  //         dispatch({ type: SELECTED_CUSTOMER_ADMIN, selectedCustomerAdmin: projectDataSearch.customers });
  //         (async() => {
  //           await ongetAllProjectCustomerList(controls.users.value.value, projectDataSearch.customers.value, projectDataSearch?.Name)
  //         })()
  //       } else {
  //         dispatch({ type: SELECTED_CUSTOMER, selectedCustomer: projectDataSearch.customers });
  //         (async() => {
  //           await ongetAllProjectCustomerList(-1, projectDataSearch.customers.value, projectDataSearch?.Name)
  //         })()
  //       }
  //       setControls({ customers: { value: projectDataSearch.customers } });
  //       dispatch(changeProjectSearch({ ...projectDataSearch, changeOut: false }));
  //       store('lsProjectDataSearch', { ...projectDataSearch, customers: projectDataSearch.customers });
  //     }
  //   }
  // },[projectDataSearch])

  useEffect(() => {
    if (projectDataSearch?.changeOut) {
      if (projectDataSearch.customers === -1) {
        setControls({
          customers: { value: controls.customers.selectItems[0] },
        });
        dispatch(
          changeProjectSearch({ ...projectDataSearch, changeOut: false }),
        );
        store("lsProjectDataSearch", {
          ...projectDataSearch,
          customers: controls.customers.selectItems[0],
        });
      } else {
        setControls({ customers: { value: projectDataSearch.customers } });
        dispatch(
          changeProjectSearch({ ...projectDataSearch, changeOut: false }),
        );
        store("lsProjectDataSearch", {
          ...projectDataSearch,
          customers: projectDataSearch.customers,
        });
        if (ALoad) {
          dispatch({
            type: SELECTED_CUSTOMER_ADMIN,
            selectedCustomerAdmin: projectDataSearch.customers,
          });
          (async () => {
            await ongetAllProjectCustomerList(
              controls.users.value.value,
              projectDataSearch.customers.value,
              projectDataSearch?.Name,
            );
          })();
        } else {
          dispatch({
            type: SELECTED_CUSTOMER,
            selectedCustomer: projectDataSearch.customers,
          });
          (async () => {
            await ongetAllProjectCustomerList(
              -1,
              projectDataSearch.customers.value,
              projectDataSearch?.Name,
            );
          })();
        }
      }
    }
  }, [projectDataSearch]);

  useEffect(() => {
    if (ALoad && allUserGroupForAdmin) {
      let usersValue = null;
      if (projectDataSearch?.users) usersValue = projectDataSearch.users;
      else if (readls?.users) usersValue = readls.users;
      else usersValue = allUserGroupForAdmin[0];
      setControls({
        users: {
          selectItems: allUserGroupForAdmin,
          value: usersValue,
          display: ALoad,
        },
      });
    }
  }, [allUserGroupForAdmin]);

  useEffect(() => {
    if (ALoad && allCustomerForAdmin) {
      let customersValue = null;
      if (projectDataSearch?.customers)
        customersValue = projectDataSearch.customers;
      else if (readls?.customers) customersValue = readls.customers;
      else customersValue = allCustomerForAdmin[0];
      setControls({
        customers: {
          selectItems: allCustomerForAdmin,
          value: customersValue,
        },
      });
    }
  }, [allCustomerForAdmin]);

  useEffect(() => {
    if (!ALoad && selectedCustomer) {
      setControls({ customers: { value: selectedCustomer } });
    }
  }, [selectedCustomer]);

  useEffect(() => {
    if (!ALoad && allCustomers) {
      let customersValue = null;
      if (projectDataSearch?.customers)
        customersValue = projectDataSearch.customers;
      else if (readls?.customers) customersValue = readls.customers;
      else customersValue = allCustomers[0];
      setControls({ customers: { selectItems: allCustomers } });
      setControls({ customers: { value: customersValue } });
    }
  }, [allCustomers]);

  const setValue = async (name, value) => {
    dispatch(changeProjectSearch({ ...projectDataSearch, Name: value }));
    store("lsProjectDataSearch", { ...projectDataSearch, Name: value });
  };

  const onSearch = async (e) => {
    e.preventDefault();
    if (ALoad)
      await ongetAllProjectCustomerList(
        controls.users.value.value,
        controls.customers.value.value,
        projectDataSearch?.Name,
      );
    else
      await ongetAllProjectCustomerList(
        -1,
        controls.customers.value.value,
        projectDataSearch?.Name,
      );
  };

  const onClearSearch = async (e) => {
    e.preventDefault();
    dispatch(changeProjectSearch({ ...projectDataSearch, Name: "" }));
    store("lsProjectDataSearch", { ...projectDataSearch, Name: "" });
    if (ALoad)
      await ongetAllProjectCustomerList(
        controls.users.value.value,
        controls.customers.value.value,
        "",
      );
    else
      await ongetAllProjectCustomerList(-1, controls.customers.value.value, "");
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    dispatch(
      changeProjectSearch({ ...projectDataSearch, [controlName]: value }),
    );
    store("lsProjectDataSearch", {
      ...projectDataSearch,
      [controlName]: value,
    });
    if (ALoad && controlName === "users") {
      try {
        setLoading(true);
        dispatch({
          type: SELECTED_USER,
          selectedUser: value,
        });
        const paramsCustomer = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          KeyRequestUser: value.value,
          All: true,
        };
        const responseCustomer = await dispatch(
          selectCustomerForAdmin(paramsCustomer),
        );
        if (responseCustomer.length > 0) {
          dispatch({
            type: SELECTED_CUSTOMER_ADMIN,
            selectedCustomerAdmin: responseCustomer[0],
          });
          await ongetAllProjectCustomerList(
            value.value,
            responseCustomer[0].value,
            projectDataSearch?.Name,
          );
          setControls({ customers: { value: responseCustomer[0] } });
          dispatch(
            changeProjectSearch({
              ...projectDataSearch,
              [controlName]: value,
              customers: responseCustomer[0],
            }),
          );
          store("lsProjectDataSearch", {
            ...projectDataSearch,
            [controlName]: value,
            customers: responseCustomer[0],
          });
        } else {
          dispatch({
            type: ALL_PROJECT_LIST,
            projectsList: [],
            projectsListPagination: { Limit: 3, Page: 1, Total: 0 },
          });
        }
        setTimeout(() => {
          setLoading(false);
        }, 250);
      } catch (err) {
        console.error("[catch error]", err);
      }
    }
    if (ALoad && controlName === "customers") {
      try {
        dispatch({
          type: SELECTED_CUSTOMER_ADMIN,
          selectedCustomerAdmin: value,
        });
        await ongetAllProjectCustomerList(
          controls.users.value.value,
          value.value,
          projectDataSearch?.Name,
        );
      } catch (err) {
        console.error("[catch error]", err);
      }
    }
    if (!ALoad && controlName === "customers") {
      try {
        dispatch({
          type: SELECTED_CUSTOMER,
          selectedCustomer: value,
        });
        await ongetAllProjectCustomerList(
          -1,
          value.value,
          projectDataSearch?.Name,
        );
      } catch (err) {
        console.error("[catch error]", err);
      }
    }
    if (controlName === "customersType") {
      try {
        await ongetAllProjectCustomerList(
          -1,
          controls.customers.value.value,
          "",
          1,
          value.value,
        );
      } catch (err) {
        console.error("[catch error]", err);
      }
    }
  };

  const ongetAllProjectCustomerList = async (
    _KeyRequestUser,
    IdCustomer,
    _search = "",
    Page = 1,
    custype,
  ) => {
    let dataSearch = null;
    if (_search !== "") dataSearch = { Name: _search };
    let exUser = null;
    if (_KeyRequestUser !== "" && _KeyRequestUser !== -1)
      exUser = { KeyRequestUser: _KeyRequestUser };
    let _customersType = 0;
    if (custype) _customersType = custype;
    else if (custype === 0) _customersType = custype;
    else _customersType = controls.customersType.value.value;
    try {
      setLoading(true);
      store("lsProjectDataSearch", { ...projectDataSearch, pagination: Page });
      if (ALoad) {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProject: 0,
          Limit: projectsListPagination.Limit,
          TypeRegister: _customersType,
          Page,
          IdCustomer,
          ...exUser,
          ...dataSearch,
        };
        await dispatch(getAllProjectCustomerList(params));
      } else {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProject: 0,
          Limit: projectsListPagination.Limit,
          Page,
          IdCustomer,
          ...dataSearch,
        };
        await dispatch(getAllProjectCustomerList(params));
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <Grid
        container
        spacing={3}
        style={{ marginTop: "32px", marginBottom: "4px" }}
      >
        {Object.keys(controls)
          .filter((i) => controls[i].type === "select" && controls[i].display)
          .map((key, index) => {
            return (
              <Grid item xs={12} sm={6} md={3} lg={2} key={key + index}>
                <MuiAutoComplete
                  options={controls[key].selectItems}
                  label={<Translator id={key} />}
                  value={controls[key].value}
                  id={key}
                  onChange={autoCompleteHandler}
                />
              </Grid>
            );
          })}
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          lg={3}
          className="d-flex flex-row align-items-end"
        >
          <Input
            setValue={setValue.bind(this)}
            name="search"
            // label={<Translator id="searchNameCode" />}
            value={projectDataSearch ? projectDataSearch?.Name : ""}
            placeholder={t("searchNameCode")}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Grid>
      </Grid>
    </>
  );
}
